// extracted by mini-css-extract-plugin
module.exports = {"SSvg":"DiceValueSvg_SSvg__fV5pB","SPath":"DiceValueSvg_SPath__ktZQr"};